import { render, staticRenderFns } from "./ImageMaterialSelector.vue?vue&type=template&id=5ad5c586"
import script from "./ImageMaterialSelector.vue?vue&type=script&lang=js"
export * from "./ImageMaterialSelector.vue?vue&type=script&lang=js"
import style0 from "./ImageMaterialSelector.vue?vue&type=style&index=0&id=5ad5c586&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports